import { createAuthClient } from '../../../../app/infrastructure/http/apiClient';
import type { UserRequestPayload } from '../../application/types';

export async function loadWalletInfo(accessToken?: string) {
  return createAuthClient(accessToken).post('/wallets/info', {});
}

export async function listWalletTransactions(walletUuid: string, accessToken?: string) {
  return createAuthClient(accessToken).get(`/wallets/${walletUuid}/transactions/list`);
}

export async function createUserRequest(payload: UserRequestPayload, accessToken?: string) {
  return createAuthClient(accessToken).post('/user-requests/', payload);
}
